export const DELETED_USER_DISPLAY_NAME = "Törölt felhasználó";

export function isDeletedUser(user: { isDeleted?: boolean | null }) {
  return user.isDeleted === true;
}

export function publicUserName(user: { username: string; displayName?: string | null; isDeleted?: boolean | null }) {
  if (isDeletedUser(user)) return DELETED_USER_DISPLAY_NAME;
  const displayName = user.displayName?.trim();
  return displayName || user.username;
}

export function userInitials(user: { username: string; displayName?: string | null; isDeleted?: boolean | null }) {
  if (isDeletedUser(user)) return "TF";
  const initials = publicUserName(user)
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();

  return initials || user.username.slice(0, 2).toUpperCase() || "U";
}
